<template>
    <WithdrawnRequests></WithdrawnRequests>
</template>
<script>
    import WithdrawnRequests from '@/components/WithdrawnRequests.vue'
    export default {
        name: 'approved-liquidations',
        components: {
            WithdrawnRequests
        }
    }
</script>